import {MessageHistory} from "../classes/chat/messageHistory";
import {FeedbackRating, FeedbackReason, MessageSendState} from "./enums";
import {IHistoryMessageState} from "../classes/chat/components/feedbackComponent";

export interface Chat {
    sendMessage( messageObject: BotMessageObject|AgentMessageObject|FeedbackRatingMessage|FeedbackReasonMessage ): void;
    initConnection():Promise<void>;
    closeConnection():Promise<void>;
    closeWebsocketConnection():Promise<void>;
    closeWidget(): void;
    minimize():Promise<void>;
    loadHistory():Promise<void>;
    waitForLoadedHistory(): Promise<void>;
    isAgentChat(): boolean;
}

export interface BotMessageObject {
    class: string,
    type: string,
    messageId: string,
    messageText: string,
    speechToText: boolean,
    trademark: string,
    client: string,
    createdAt: string
}

export interface BotMessageSendObject {
    class: string,
    type: string,
    messageId: string,
    sessionId: string,
    userChatSessionId: string,
    messageText: string,
    speechToText: boolean,
    trademark: string,
    client: string,
    subscriberId: number,
    createdAt: string
}

export interface BotReportingEventObject {
    type: string,
    messageId: string,
    id: string,
    event: string,
    url: string,
    client: string,
    subscriberId: number,
    userSessionId: string,
    trademark: string,
    createdAt: string
}

export class HistoryMessage {
    private type: string = 'Message';
    private class: string = 'History';
}

export class SessionTimeoutMessage {
    private type: string = 'Event';
    private class: string = 'SessionTimeout';
}

export class PingMessage {
    private type: string = 'Message';
    private class: string = 'Ping';
}

export interface SummaryMessage {
    class: string,
    type: string,
    summary: string
}

export interface AiHistoryMessage {
    class: string,
    type: string,
    text: string,
    originatingEntity: string,
    current: number,
    count: number,
    isLastMessage: boolean
}

export interface AgentEventObject {
    class: string;
    type: string;
}

export interface AgentMessageObject extends AgentEventObject {
    messageId: string;
    text: string;
    time: string;
    speechToText: boolean;
}

export interface JoinObject extends AgentEventObject {
    chatSessionId: string;
    chatType: string;
    trademark: string;
    customerFirstName: string;
    customerLastName: string;
}

export interface LeaveObject extends AgentEventObject {
    originatingEntity: string
}

export interface TypingObject extends AgentEventObject {
}

export interface ResponseObject {
    answerHtml: string,
    responseId: string,
    messageId: string,
    author: string,
    time: string,
    isError: boolean,
    useDefaultHtml: boolean
}

export interface Response {
    success: boolean;
    messageText: string;
}

export interface OutputMessageObject {
    id: string,
    text: string,
    type: string,
    cssClass: string,
    author: string,
    time: string|Date,
    messageId: string,
    responseId: string,
    status: MessageSendState,
    historyMessageState: IHistoryMessageState | null,
}

export interface FeedbackMessage {
    type: string,
    messageId: string,
    trademark: string,
    client: string,
    subscriberId: number|null,
    sessionId: string,
    userSessionId: string
}

export interface FeedbackRatingMessage extends FeedbackMessage {
    id: string,
    rating: FeedbackRating
}

export interface FeedbackReasonMessage extends FeedbackMessage {
    id: string,
    reasonCode: FeedbackReason|null,
    freeText: string|null // max 350 chars, nur bei reasonCode=other
}

export interface ComponentInterface {
    setAnswerContent(chatType: string, responseData: ResponseObject): void;
    changeMessageStatus( id: string, status: MessageSendState ): void;
    setAgentIsTyping(duration: number): void;
    closeChatByAgent(): void
    closeChat(isError: boolean|null ): void;
    closeWidget(): void;
    minimizeChat( ): void;
    setHistoryContent(chatType: string, messageHistory:MessageHistory): void;
    handleInvalidChatSessionError( errorType: string ): void;
    resetSystemError( errorType: string ): void;
    showBotSuggestions( ): void;
    showBotGreeting( ): void;
}